import { handleActions } from 'redux-actions'
import get from 'lodash/get'

import { initialState, CodeTableState as State, CodeText, LoanRange } from './model'
import { Payload } from '../../../types'
import { prepareActions } from '../../../utils/redux'

const actionsNames = ['saveCodetables', 'saveStayDurations', 'saveLoanRanges', 'getAddressHints']

interface Actions {
  saveCodetables: any
  saveStayDurations: any
  saveLoanRanges: any
  getAddressHints: any
}

export const actions: Actions = prepareActions(actionsNames, 'codetable') as Actions

export default handleActions<State, Payload>(
  {
    [actions.saveCodetables]: (state, action): State => {
      const codetables: any = get(action, 'payload')
      return state.merge(codetables)
    },
    [actions.saveStayDurations]: (state, action): State => {
      const stayDurations: CodeText[] = get(action, 'payload')
      return state.merge({ stayDurations })
    },
    [actions.saveLoanRanges]: (state, action): State => {
      const loanRanges: LoanRange[] = get(action, 'payload')
      return state.merge({ loanRanges })
    },
  },
  initialState
)
